export const validatelogin = (fields) => {
  const isValid = {};

  if (!fields?.email || fields?.email === '') {
    isValid.EmployeeEmailId = 'Enter email';
  }
  if (!fields?.password || fields?.password === '') {
    isValid.password = 'Enter password';
  }
  //  else if (!/^[a-zA-Z0-9]+@+[a-zA-Z0-9]+.+[A-z]/.test(fields?.EmployeeEmailId)) {
  //   isValid.EmployeeEmailId = 'Enter a valid Email';
  // }

  return isValid;
};
